import {
  GET_PRODUCT,
  GET_PRODUCT_FAIL,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCTS,
  GET_PRODUCTS_FAIL,
  GET_PRODUCTS_SUCCESS,
  ADD_NEW_PRODUCT,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT_FAIL,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  DELETE_PRODUCT,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAIL,
  SET_STATE_PRODUCT,
  UPDATE_PRODUCT_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_PRODUCT,
  payload: loading,
})

export const getProducts = ( params ) => ({
  type: GET_PRODUCTS,
  payload: { params },
})

export const getProductsSuccess = (products, totalPages, currentPage) => ({
  type: GET_PRODUCTS_SUCCESS,
  payload: { products:products, total:totalPages, currentPage:currentPage}
})

export const getProductsFail = error => ({
  type: GET_PRODUCTS_FAIL,
  payload: error,
})

export const addNewProduct = product => ({
  type: ADD_NEW_PRODUCT,
  payload: product,
})

export const addProductSuccess = product => ({
  type: ADD_PRODUCT_SUCCESS,
  payload: product,
})  

export const addProductFail = error => ({
  type: ADD_PRODUCT_FAIL,
  payload: error,
})

export const updateProduct = product => ({
  type: UPDATE_PRODUCT,
  payload: product,
})

export const updateProductStatus = product => ({
  type: UPDATE_PRODUCT_STATUS,
  payload: product,
})

export const updateProductSuccess = product => ({
  type: UPDATE_PRODUCT_SUCCESS,
  payload: product,
})

export const updateProductFail = error => ({
  type: UPDATE_PRODUCT_FAIL,
  payload: error,
})

export const deleteProduct = product => ({
  type: DELETE_PRODUCT,
  payload: product,
})

export const deleteProductSuccess = id => ({
  type: DELETE_PRODUCT_SUCCESS,
  id,
})

export const deleteProductFail = error => ({
  type: DELETE_PRODUCT_FAIL,
  payload: error,
})

export const getProduct = () => ({
  type: GET_PRODUCT,
})

export const getProductSuccess = product => ({
  type: GET_PRODUCT_SUCCESS,
  payload: product,
})

export const getProductFail = error => ({
  type: GET_PRODUCT_FAIL,
  payload: error,
})
